<script>

import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";
import Swal from "sweetalert2";
import moment from "moment";

export default {
  setup() {
    return { v$: useVuelidate() };
  },
  components: {

  },
  props: {
    notasInuteisList: {
      type: Array,
      default: function () {
        return [];
      },
    }
  },
  validations: {
    regSelecionado :{
      justific: {
        required: helpers.withMessage("Campo justificativa obrigatório, favor preencher.", required),
      },
      numero: {
        required: helpers.withMessage("Campo número obrigatório, favor preencher.", required),
      },
      serie: {
        required: helpers.withMessage("Campo código obrigatório, favor preencher.", required),
      },
    }
  },
  mounted() {
    // console.log('mounted notasInuteis-table_0')
    // console.log(this.updating)
  },
  methods: {

    nomeStatus(strEntr){
      let result = 'Não Definido'
      switch (strEntr) {
        case 'A':
          result = 'Ativo'
          break
        default:
          result = 'Inativo'
          break
      }
      return result
    },

    editar(dataID){
      console.log('editar: ' + dataID)
      this.showModal = true
      this.regSelecionado = this.notasInuteisList.find((reg) => reg.id === dataID);
      console.log('regSelecionado: ')
      console.log(this.regSelecionado)
    },

    deletar(dataID){
      console.log('deletar: ' + dataID)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {
          this.$emit('deletareg', dataID)
        }
      })
    },

    formSubmit() {
      console.log('formSubmit_0')
      this.submitted = true
      this.v$.$touch()
      if (this.v$.$invalid) {
        return;
      } else {
        console.log('formSubmit_validado')
        this.showModal = false
        this.$emit('alterareg', this.regSelecionado)
      }
    },

    setCriarNova: function() {
      this.regSelecionado = {}
      this.submitted = false
      this.showModal = true
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  },
  data() {
    return {
      regSelecionado: {},
      submitted: false,
      showModal: false,
    };
  },
};
</script>

<template>
  <div class="table-responsive mb-0">
    <table class="table align-middle table-nowrap" v-if="notasInuteisList">
      <thead class="table-light">
      <tr>

        <th class="align-middle">ID</th>
        <th class="align-middle">Série</th>
        <th class="align-middle">Número</th>
        <th class="align-middle">Justificativa</th>
        <th class="align-middle">Retorno</th>
        <th class="align-middle">Data</th>
        <th class="align-middle">Ações</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="data in notasInuteisList" :key="data.id">
        <td>
          <a href="javascript: void(0);"
             class="text-body fw-bold"
             @click="editar(data.id)">{{ data.id }}
          </a>
        </td>
        <td>{{ data.serie }} </td>
        <td>{{ data.numero }} </td>
        <td>{{ data.justific }} </td>
        <td>{{ data.retorno }} </td>
        <td>{{ formatDateTime(data.created_at) }} </td>

        <td>

          <div class="button-items">

            <b-button variant="outline-success" @click="editar(data.id)">
              <i class="mdi mdi-pencil d-block font-size-16"></i>
            </b-button>

            <b-button variant="outline-danger" @click="deletar(data.id)">
              <i class="mdi mdi-trash-can d-block font-size-16"></i>
            </b-button>

          </div>

        </td>

      </tr>
      </tbody>
    </table>

    <b-modal :title="regSelecionado.id != null ? `Editar Inutilização de Nota Fiscal (${ regSelecionado.id })` : 'Criar Inutilização de Nota Fiscal'" v-model="showModal" hide-footer>
      <form @submit.prevent="formSubmit">
        <div class="row">

          <div class="col-12">
            <div class="mb-3">
              <label for="justific">Justificativa</label>
              <input
                  id="justific"
                  v-model="regSelecionado.justific"
                  type="text"
                  class="form-control"
                  placeholder="Inserir justificativa"
                  :class="{'is-invalid': submitted && v$.regSelecionado.justific.$error,}"/>
              <div
                  v-if="submitted && v$.regSelecionado.justific.$error"
                  class="invalid-feedback">
                <span v-if="v$.regSelecionado.justific.required.$message">
                  {{ v$.regSelecionado.justific.required.$message }}
                </span>
              </div>
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="serie">Série</label>
              <input
                  id="serie"
                  v-model="regSelecionado.serie"
                  type="text"
                  class="form-control"
                  placeholder="Inserir Série"
                  :class="{'is-invalid': submitted && v$.regSelecionado.serie.$error,}"/>
              <div
                  v-if="submitted && v$.regSelecionado.serie.$error"
                  class="invalid-feedback">
                <span v-if="v$.regSelecionado.serie.required.$message">
                  {{ v$.regSelecionado.serie.required.$message }}
                </span>
              </div>
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="numero">Número</label>
              <input
                  id="numero"
                  v-model="regSelecionado.numero"
                  type="text"
                  class="form-control"
                  placeholder="Inserir Série"
                  :class="{'is-invalid': submitted && v$.regSelecionado.numero.$error,}"/>
              <div
                  v-if="submitted && v$.regSelecionado.numero.$error"
                  class="invalid-feedback">
                <span v-if="v$.regSelecionado.numero.required.$message">
                  {{ v$.regSelecionado.numero.required.$message }}
                </span>
              </div>
            </div>
          </div>



        </div>

        <div class="text-end mt-3">
          <b-button variant="light" @click="showModal = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Fechar
          </b-button>
          <b-button variant="success" class="ms-1" @click="formSubmit">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>

      </form>

    </b-modal>
  </div>

</template>
